// Internet Explorer 11 requires polyfills and partially supported by this project.
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import './i18n';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import App from './app/App';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
